import theme from './config';
import {Config} from "../_core/types/Config.type";

const config = {
    theme
} as Config;

export default config
